import React, { useEffect, useState } from 'react'
import { BasicHabilitationAccordion } from '../access/HabilitationAccordion'
import { PRODUCTION } from '../../../constants/ApplicationHabilitationConstants'
import i18n from '../../../../../../simple-react-i18n'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import ProductionUnitAction from '../../../../../../productionUnit/actions/ProductionUnitAction'
import DtoProductionUnit from '../../../../../../productionUnit/dto/DtoProductionUnit'

const HabilitationProduction = ({}) => {
    const dispatch = useDispatch()
    const {
        productionUnits,
    } = useSelector(store => ({
        productionUnits: store.ProductionUnitReducer.productionUnits,
    }), shallowEqual)

    const [isLoaded, setIsLoaded] = useState(false)

    useEffect(() => {
        if (productionUnits.length === 0) {
            dispatch(ProductionUnitAction.fetchProductionUnits())
                .then(() => setIsLoaded(true))
        } else {
            setIsLoaded(true)
        }
    }, [dispatch])

    return (
        <BasicHabilitationAccordion
            stationType={PRODUCTION}
            title={i18n.productionUnit}
            stations={productionUnits}
            isLoaded={isLoaded}
        />
    )
}

HabilitationProduction.propTypes = {
    productionUnits: PropTypes.arrayOf(PropTypes.instanceOf(DtoProductionUnit)),
    fetchProductionUnits: PropTypes.func,
}

export default HabilitationProduction